/**
 * 国际化翻译约定规范：
 * en中的key要与zh的key一致，才能保证中英切换成功
 * en中value值每个单词的首字母要大写
 * example：
 * personalpwd: "Change Password", --> personalpwd: "修改密码",
 * // Change Password 每个单词的首字母大写（样例）
 * 使用方法：
 * 普通文本：$t('route.personalpwd')
 * JS使用：this.$t('route.personalpwd')
 */
export default {
  system: {
    Cold_chain_system: 'FreshMon Management Portal'
  },
  route: {
    home: 'Home',
    monitor: 'Monitoring',
    application: 'Application',
    business: 'Asset',
    device: 'Device Name',
    exception: 'Abnormal',
    account: 'Account',
    log: 'Log',
    sys: 'System',
    instance: 'Device Data',
    map: 'Map',
    grid: 'List Data',
    scene: 'Organization',
    history: 'Historical Data',
    monitorTask: 'Detection Task',
    proberange: 'Monitoring Range',
    collectRecord: 'Readings',
    contact: 'Contact',
    alarmTrigger: 'Alarm Trigger',
    incubator: 'Incubator',
    fridge: 'Refrigerator',
    car: 'Refrigerated Truck',
    refrigeratory: 'Cold Storage',
    // sensor: 'Sensor',
    sensor: 'Temp & HR Sensor',
    gateway: 'Gateway',
    display: 'Digital Display',
    relay: 'Repeater',
    base: 'Smart Bracket',
    ex: 'Abnormal Records',
    exReason: 'Abnormal Causes',
    user: 'User Count',
    role: 'Role',
    noticelog: 'Notice Log',
    sysLog: 'System Log',
    alarmLog: 'Alarm Toggle Log',
    param: 'Parameter',
    forwarding: 'Forwarding Settings',
    resource: 'Resource',
    probeunit: 'Measurement Unit',
    customer: 'Company',
    carrierType: 'Asset Type',
    deviceType: 'Device Type',
    dataBoard: 'Instance View',
    deviceMonitor: 'Device Monitor',
    monitoringPoint: 'Asset',
    Map: 'Map',
    count: 'Report&Statistics',
    detailData: 'Data Details',
    download: 'Download',
    workOrder: 'Work Order',
    // 前端添加
    personalinfo: 'User Profile',
    historyData: 'Historical Records',
    realtime: 'Real-time Data',
    operateRecord: 'Actions History',
    alarmRecord: 'Alarm Records',
    findCode: 'Query Code',
    loginCode: 'Login Code',
    monitorPointRealTime: 'Real-time Status of Asset',
    deviceTransfer: 'Device Loan',
    warehouse: 'Warehouse',
    store: 'Store',
    onlineHelp: 'Online Help Settings',
    statistic: 'Statistics',
    other: 'Other',
    verificationTask: 'Verification Task',
    invalidRule: 'Invalid Rule',
    exportTask: 'Export Task',
    overview: 'Overview',
    gas: 'Gas',
    magnetism: 'Door Sensor',
    air: 'Air',

    // personal: "Profile",
    // personalinfo: "Edit Profile",
    // personalpwd: "Edit Password",
    // monitor: "Monitoring",
    // dataMonitor: "Map View",
    // gridMonitor: "List View",
    // device: "Manage",
    // scene: "Organization",
    // viewHistory: "Historical Data",
    // monitorRange: "Range",
    // extend: "Tag",
    // maintain: "Maintenance",
    // business: "Select Asset",
    // incubator: "Incubator",
    // fridge: "Refrigerator",
    // car: "Refrigerated Truck",
    // refrigeratory: "Cold Storage",
    // eq: "Device Name",
    // sensor: "Select Sensor",
    // gateway: "Gateway",
    // exception: "Abnormal",
    // alarmrecord: "Data Abnormal Records",
    // count: "Statistics & Report ",
    // download: "Report",
    // account: "Administration",
    // accountinfo: "User Info",
    // roleright: "Role & Auth.",
    // log: "Log",
    // noticelog: "Notification Log",
    // sys: "System",
    // task: "Schedule Tasks",
    // param: "Parameter",
    // setting: "Global Settings",
    // syscustom: "Customization",
    // connarmrecord: "Offline",
    // outagearmrecord: "Power Alerts",
    // temptimerecord: "Time Point",
    // forwarding: "Forwarding Settings",
    // mqttManager: "MQTT",
    // monitorInstance: 'Instance View',
    // terminal: 'Show Label',
    // relay: 'Repeater',
    // operatelog: 'Action Log',
    // Home: 'Home',
    // HomeSet: 'Home Setting',
    // carrier: 'Select Asset',
    // historyData: 'Historical Records',
    // addUser: 'New User',
    // editUser: 'Edit User',
    // addRole: 'Create Role',
    // editRole: 'Edit Role',
    // scopeManage: 'Scope Management',
    // ForwardingSettings: 'Forwarding Settings',
    // thermometer: 'Thermometer',
    // addShortcutbar: 'add Shortcutbar',
    addShortcutbar: 'Add Shortcut',
    // guideInstance: 'guideInstance',
    // onlineHelp: 'Online Help',
    // ATInstruction: 'AT-Instruction',
    // /** 修正路由文件的name国际化 */
    // Associated: 'Associated equipment',
    // Sensorsetup: 'Sensor configuration',
    // Portadmin: 'Interface management',
    // OnlineHelpContent: 'Online help document content',
    // PastdatumHome: 'Map history data',
    // Pastdatum: 'Historical data',
    // PastdatumOne: 'Map data',
    // Realtime: 'Real-time Data',
    // Flatgraph: 'Flatgraph',
    // CanvasName: 'Real-time',
    // UserInfoCanvasName: 'Autograph',
    // AlarmGroup: 'AlarmGroup',
    // Guide: 'Guide',
    // printer: 'PrintSeting',
    // CarrierDetail:'Carrier Detail',
    // resource:'Resource',
    // probeunit:'Measurement Unit',
    // collectRecord:'Sampling Record',
    // abnormalCause:'abnormal Cause',
    // sysLog:'System Log',
    // person:'person',
    // sysAlarm:'sysAlarm',
    // customer:'Customer',
    // ex:'Abnormal',
  },

  // 按钮标题
  buttonTitle: {
    clickSeeMore: 'More Information',
    LoggingIn: 'Login In...',
    Details: 'Details',
    SwitchOff: 'Close',
    Close_other: 'Close Other',
    Close_left: 'Close Left',
    Close_right: 'Close Right',
    Close_all: 'Close All',
    Inquiresearch: 'Search',
    Reset: 'Reset',
    Edit: 'Edit',
    Delete: 'Delete',
    Confirm: 'Confirm',
    Save: 'Save',
    Return: 'Back',
    'Next Step': 'Next',
    'Previous Step': 'Previous',
    Refresh: 'Auto Refresh Time',
    Cancel: 'Deactivate',
    Close: 'Close',
    'Add Extended Attributes': 'New',
    Submit: 'Confirm',
    Rewrite: 'Overwrite',
    'Submit And Save Signature': 'Save & Apply',
    clear: 'Clear',
    Add: 'New',
    Add1: 'New',
  },
  // 文本
  text: {
    Shortcut_bar: 'Shortcut',
    Left_menu_bar: 'Navigate',
    Set_shortcut_bar_menu: 'Set Shortcut',
    language: 'Language',
    Complete: 'Done',
    Day: 'days',
    hour: 'hour',
    min: 'min',
    Switching: 'Compiling...',
    // Save_and_return: 'Save and Return',
    // Home_page_style: 'Homepage Style',
    // total: 'total',
    Exception_type: 'Abnormal Type',
    // Abnormal_information_statistics: 'Abnormal Info. Statistics',
    // Left_content_selection: 'Set Left Sidebar',
    // Right_content_selection: 'Set Right Sidebar',
    test: 'Test',
    show: 'Show Label',
    Example: 'Example',
    ExampleTooltip:
      'Custom tags are used to extend asset information. The tags will be showed in the asset details.',
    CustomLabel: 'Custom Tag',
    UserLogin: 'Welcome Back',
    UserLoginSubtitle: 'Sign in to your monitoring dashboard.',
    UserLoginChip1: '24h Real-time',
    UserLoginChip2: 'Temp&Humi',
    UserLoginChip3: 'Device Status',
    UserLoginChip4: 'History',
    CarrierType: 'Asset Type',
    Thermometer: 'Temp&RH Sensor',
    Thermograph: 'Temperature',
    Thermometer2: 'Gen2 Temp&RH Sensor',
    Thermograph2: 'Gen2 Temperature Sensor',
    'Refresh Interval (Minutes)': 'Refresh(Min)',
    Architecture: 'Organization Node',
    HistoricalDataLineChart: 'Historical Data Line Chart',
    Time: 'Time',
    Vehicle: 'Refrigerated Truck',
    location: 'Current Location',
    address: 'Address',
    Node_ontent: 'Email Content',
    'Reason For Data Exception': 'Abnormal Causes',
    Activated: 'Enable',
    // Details: 'Details',
    'Forwarding Settings': 'Forwarding Settings',
    'Add Forwarding Settings': 'New Forwarding Settings',
    Loading: 'Loading...',
    Interval: 'Range',
    total: 'Total',
    SentSuccessfully: 'Send Successful',
    Search: 'Search',
    Address: 'Address',
    Phone: 'Contact Details',
  },
  placeholderText: {
    EnterUsername: 'Please enter the username.',
    EnterPassword: 'Please enter password.',
    EnterPasswordAgain: 'Please enter password again.',
    TwoPasswordInconsistent: 'Passwords do not match.',
    EnterTimeout: 'Please enter the timeout.',
    '6_15Char': 'Length must be between 6 and 15 characters.',
    EnterSensorSerialNumber: 'Please enter  Sensor ID.',
    SelectTimeOrDate: 'Please select time or date.',
    TypeInYourName: 'Please input your name.',
    Choose: 'Please Select',
    EnterYourEmail: 'Please enter your Email.',
    SelectArchitecture: 'Please select an organization.',
    EnterUserName: 'Please enter the username.',
    EnterPhoneNumber: 'Please enter Phone Number.',
    EnterContent: 'Please enter content.',
    ChooseStartTime: 'Select Start Time',
    EnterExTime: 'Please enter the abnormal delay time.'
  },
  // 下拉选信息
  selectMsg: {
    Chinese: 'Chinese',
    English: 'English',
    Japance: 'Japanese',
    Logout: 'Logout',
    EditProfile: 'Edit Profile',
    RegistrationFailed: 'Registration Failed',
    AlarmType: 'Alarm Type',
    Yes: 'Confirm',
    effective: 'Valid',
    Customize: 'Customize',
    Offline: 'Offline',
    Online: 'Online',
  },
  // 表单标题
  labelTitle: {
    label: 'Tag',
    display_name: 'Display Name',
    password: 'Password',
    // Duration: 'Duration(s)',
    'Digital Signature': 'Digital Signature',
    Signature: 'Use E-signature?',
    'Use selected signature': 'Apply Selected Signature',
    'Old Password': 'Old Password',
    'New Password': 'New Password',
    'Confirm Password': 'Confirm Password',
    Name: 'Instance Name',
    Status: 'Status',
    Device: 'Device Name',
    'Internationalized Text': 'Internationalized Text',
    Sensor: 'Select Sensor',
    current_location: 'Current Location',
    'To (End Period)': 'to',
    'Processing Remark': 'Handling Notes',
    Range: 'Company',
    UpdateTime: 'Update Time',
    Temperature: 'Temperature',
    Humidity: 'RH(%RH)',
    'Carrier Information': 'Asset Information',
    DeviceBinding: 'Device Binding',
    'Operation History': 'Operation History',
  },
  // 表格标题
  tableTitle: {
    GatewayDisabled: 'Deactivate Gateway',
    startingTime: 'Start Time',
    endTime: 'End Time',
    Operating: 'Actions',
    Carrier: 'Select Asset',
    'real-time_data': 'Real-time Data',
    historical_data: 'History Data',
    Indicator: 'Range',
    'Collection Time': 'Reading Time',
    Range: 'Range',
    Operation: 'Actions',
    'Created Time': 'Created Time',
    'Creation Time': 'Creation Time',
    'Sensor Serial Number': 'Sensor ID',
    'Asset Name': 'Asset Name',
    Result: 'Return Result',
    'Method Of Reason Selection': 'Cause Type',
    Reasons: 'Causes',
    // 'Passing Rate': 'Passing Rate',
    remark: 'Tips',
    'Platform Name': 'Platform',
    'Platform ID': 'Platform ID',
    params: 'Parameter',
    OperatingUser: 'Operating User'
  },
  // 系统设置
  // 消息提示框
  messageTitle: {
    // 'Command generated and ready to send.':'Command generated and ready to send.',
    SelectACarrierInTheSameRange: 'Please select assets under the same scope.',
    ExitFailed: 'Exit Failed',
    ReasonCanNotBeEmpty: 'The causes are required.',
    UploadedFileCanOnlyBeInXlsx:
      'Only xlsx format is allowed.',
    DragFilesHere: 'Drag files here for Uploading',
    ClickToUpload: 'Click To Upload',
    Or: 'Or ',
    ModifiedSuccessfully: 'Update Successful',
    OperatedSuccessfully: 'Operated Successfully',
    DeleteFailed: 'Deletion Failed',
    DeleteToContinue:
      'This operation will permanently delete this information. Continue?',
    Yes: 'Confirm',
    Cancel: 'Deactivate',
    NameExit: 'Name already exists',
    ConfirmToLogOutOfAccount: 'Please confirm to logout the system.',
    runCheckTaskNotToDel: 'Cannot delete a running inspection task.',
    PleaseTickAtLeastOne: 'Please check one at least',
    CannotBeEmpty: 'This field is required.',
    SelectTheNodeUnderTheRange: 'Please select the node under the company.',
    UsernameCannotBeEmpty: 'Account is required.',
    PasswordCannotBeEmpty: 'Password is required.',
    VerificationCodeCannotBeEmpty: 'Verification Code is required.',
    PleaseSelectArchit: 'Please select an organization.',
    PleaseFillInThePassword: 'Please enter the password.',
    IncorrectPassword: 'Incorrect password.',
    ContentNotEmpty: 'Content of info. is required.',
    PleaseChooseATime: 'Please select time.',
    SystemException: 'System Abnormal',
    AddressAlreadySave: 'Address Saved',
    '2_20Character': 'Length must be between 2 and 20 characters.',
    'CharacterLengthAt4-20': 'Length must be between 4 and 50 characters.',
    CharacterLengthAt4: 'Length must be exactly 4 characters.',
    RangeCanNotBeEmpty: 'Please enter the scope.',
    TextFormat: 'TextFormat:{"zh_CN":"汤姆","en_US":"Tom"}',
  },
  week: {
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday'
  },
  // 对话框标题
  dialogTitle: {
    TableData: 'Table Data',
    SelectTimeZone: 'Time Zone',
    EditSensorDescription: 'Edit Sensor Description',
    EditSensor: 'Edit Sensor',
    Edit: 'Edit',
    AddMonitoringInterval: 'New Range',
    EditMonitoringInterval: 'Edit Data Zone',
    DetailContent: 'Details',
    Process: 'Handle',
    AddDisplayScreen: 'New',
    AddGateway: 'New',
    AddSensor: 'New',
    ManageAlarmObjects: 'Manage Alarm Recipients',
    SetSwitch: 'Toggle Setting',
    EditDisplayScreen: 'Edit Display',
    Confirm: 'Confirm',
    ImportSensor: 'Import Display',
    ImportGateway: 'Import Display',
    ImportRelay: 'Import Repeater',
    ImportDisplay: 'Import Display',
    EditGatewayRouter: 'Edit Gateway',
    AddGatewayRouter: 'New Gateway',
    Prompt: 'Tips',
    ShowTableColumn: 'Configure Visible Columns',
    ConfigTable: 'Configuration Table',
    UnselectedColumn: 'Selectable Visible Columns',
    SelectedColumn: 'Display Column ',
    ImportGas: 'Import Gas Sensor',
    ImportMagnetism: 'Import Door Sensor',
  },
  //  复选框标题
  //  校验规则
  validateRule: {
    ReasonCanNotBeEmpty: 'Reason is required',
    ParameterNotEmpty: 'Parameter is required',
    PlatformCodeNotEmpty: 'Platform ID is required',
    PlatformNameNotEmpty: 'Platform name is required',

    PlatformCodeNotEmpty1: 'Platform ID already exists',
    PlatformNameNotEmpty1: 'Platform name already exists',

    ServerEmpty: 'Server name is required',
    hostEmpty: 'Host address is required.',
    postEmpty: 'Port is required',
    clientIdEmpty: 'Client_id is required.'
  },
  //  原生表格
  // 首页风格设置
  /**
   * @description: 系统向导国际化
   * @param {*guideText}
   * @return {*}
   */
  guideText: {
    Complete: 'Done',
    /** 传感器大小值的变化 */
    /** 后续补充 */
    Maximum_value27: 'The same ID already exists in the same scope.',
  },
  /**
   * @description: 迭代2至5期的国际化   设备管理模块
   * @param {* langText}
   * @return {*}
   */
  langText: {
    /** 传感器 */
    /** --------- */
    /** -------------- 2-5的校验 */
    /** input输入提示语 */
    /** 传感器设备日志表格 */
    StartTime_chooze: 'Select Start Time',
    EndTime_chooze: 'Select End Time',
    /** 其他 */
    /** 传感器大小值的变化 */
    /** 网关路由 */
    /** 显示屏 */
    Alarm_duration: 'Alarm Duration',
  },
  // 计划任务国际化
  // task: {
  //   'RemoveInterface': 'Remove interface call batch data query status code',
  //   'Check Sensor Connection': 'Detect sensor failure',
  //   'Check Display Connection': 'Detect Display failure',
  //   'Check Gateway Connection': 'Detect Gateway failure',
  //   'Check Repeater Connection': 'Detect Relay failure',
  // },
  /** 迭代第七版 */
}
